export const UserSettingsUpdatedEventName = 'userSettingsUpdated';
export const WebSocketUserSettingsUpdatedEventName = 'webSocketUserSettingsUpdated';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_domain/models/events.ts